import cars from './data/cars.json'
import carGalleries from './data/carGalleries.json'
import languages from './data/languages.json'
import countries from './data/countries.json'

export const createPrefixOfUrl = () => process.env.REACT_APP_ROOT_URL
export const createPrefixOfResource = () => process.env.PUBLIC_URL

export const getCarInfo = (carId, carCode = false) => {
    let blankInfo = {
        "id": null,
        "carCode": null,
        "carSrc": null,
        "brandSrc": null,
        "brandHTML": null,
        "brand": null,
        "titleBrand": null,
        "modelSrc": null,
        "modelMobileSrc": null,
        "exteriorValue": '',
        "interiorValue": '',
        "defaultColorID": null,
        "bookOnlineLink": null,
        "colors": [],
        "seats": [],
        "wheels": [],
        "spots_exterior": [],
        "spots_interior": [],
        "gallery": [],
        "multimedias": [],
        "menu": [],
        "showroomPosition": null,
        "lightOnOff": false
    }
    if (carId === null)
        return blankInfo
    let info = cars.find(ele => carId === (carCode === true ? ele.carCode : ele.id))
    if (info === undefined) {
        return blankInfo
    }
    return info
}

export const getCarGalleryInfo = (carId, carCode = false) => {
    if (carId === null)
        return {
            "id": null,
            "carCode": null,
            "gallery": [],
        }
    let info = carGalleries.find(ele => carId === (carCode === true ? ele.carCode : ele.id))
    return info
}

export const getLanguageInfo = (langId) => {
    if (langId === null)
        return {
            "id": null,
            "title": "",
            "rtl": false,
            "selectSrc": null,
            "unselectSrc": null
        }
    let info = languages.find(ele => ele.id === langId)
    return info
}

export const getCountryInfo = (cntryId) => {
    if (cntryId === null)
        return {
            id: null,
            fullName: null,
            flagImage: null,
            toplinkVisible: false,
        }
    let info = countries.find(ele => ele.id === cntryId)
    return info
}

export const trackAdobeDtm = (properties, trackValue) => { }

export const gtmPageView = (page_type, vehicle_name = '', vehicle_code = '', inOrEx = '') => {
    if (window.firstLoad) {
        window.dataLayer.push({
            'event': 'manual_page_view',
            'page_type': page_type,
            ...page_type === 'vehicle' ? { 'vehicle_name': vehicle_name, } : {},
            'layered_page': page_type === 'vehicle' ? `vr|handson_apac|${vehicle_code}|${inOrEx}` : `vr|handson_apac|showroom`
        })
        window.firstLoad = false
    } else {
        window.dataLayer.push({
            'event': 'virtual_page_view',
            'page_type': page_type,
            ...page_type === 'vehicle' ? { 'vehicle_name': vehicle_name, } : {},
            'page_path': window.location.pathname + window.location.hash,
            'page_title': page_type === 'vehicle' ? `${vehicle_name} - ${inOrEx.toLocaleUpperCase()}` : 'Showroom',
            'layered_page': page_type === 'vehicle' ? `vr|handson_apac|${vehicle_code}|${inOrEx}` : `vr|handson_apac|showroom`
        })
    }
    window.dataLayer.push({ vehicle_name: undefined })
}

export const gtmNavigationAction = (event_action, event_label) => {
    window.dataLayer.push({
        'event': 'navigation',
        'event_category': 'navigation',
        'event_action': event_action.replace('<br />', ' ').replace('<br/>', ' '),
        'event_label': event_label.replace('<br />', ' ').replace('<br/>', ' ')
    })
    window.dataLayer.push({
        'event_category': undefined,
        'event_action': undefined,
        'event_label': undefined,
        'vehicle_name': undefined
    })
}

export const gtmNavigationInteraction = (event_action, event_label, vehicle_name) => {
    window.dataLayer.push({
        'event': 'navigation',
        'event_category': 'navigation',
        'event_action': event_action.replace('<br />', ' ').replace('<br/>', ' '),
        'event_label': event_label.replace('<br />', ' ').replace('<br/>', ' '),
        'vehicle_name': vehicle_name
    })
    window.dataLayer.push({
        'event_category': undefined,
        'event_action': undefined,
        'event_label': undefined,
        'vehicle_name': undefined
    })
}

export const gtmNavigationInteractionWithCustomFields = (event_action, event_label, vehicle_name, customFields = {}) => {
    let filteredFields = { ...customFields }
    Object.keys(customFields).map(key => filteredFields[key] = customFields[key].replace('<br />', ' ').replace('<br/>', ' '))
    window.dataLayer.push({
        'event': 'navigation',
        'event_category': 'navigation',
        'event_action': event_action.replace('<br />', ' ').replace('<br/>', ' '),
        'event_label': event_label.replace('<br />', ' ').replace('<br/>', ' '),
        'vehicle_name': vehicle_name,
        ...filteredFields,
    })
    let resetCustomFields = { ...customFields }
    Object.keys(customFields).map(key => resetCustomFields[key] = undefined)
    window.dataLayer.push({
        'event_category': undefined,
        'event_action': undefined,
        'event_label': undefined,
        'vehicle_name': undefined,
        ...resetCustomFields
    })
}

export const gtmAccordionInteraction = (event_label, vehicle_code,) => {
    window.dataLayer.push({
        'event': 'accordion_interaction',
        'event_category': 'navigation',
        'event_action': 'model menu',
        'event_label': event_label.replace('<br />', ' ').replace('<br/>', ' '),
    })
    window.dataLayer.push({
        'event_category': undefined,
        'event_action': undefined,
        'event_label': undefined,
    })
}

export const gtmAccordionInteractionWithVehicle = (event_action, event_label, vehicle_name,) => {
    window.dataLayer.push({
        'event': 'accordion_interaction',
        'event_category': 'navigation',
        'event_action': event_action.replace('<br />', ' ').replace('<br/>', ' '),
        'event_label': event_label.replace('<br />', ' ').replace('<br/>', ' '),
        'vehicle_name': vehicle_name
    })
    window.dataLayer.push({
        'event_category': undefined,
        'event_action': undefined,
        'event_label': undefined,
        'vehicle_name': undefined
    })
}

export const gtmChangeLayeredPage = (vehicle_code, subString) => window.dataLayer.push({
    'layered_page': `vr|handson_apac|${vehicle_code}|${subString.replace('<br />', ' ').replace('<br/>', ' ')}`
})

export const gtmModelPageInteraction = (event_action, event_label, vehicle_name) => {
    window.dataLayer.push({
        'event': 'model_page_interactions',
        'event_category': 'model page',
        'event_action': event_action.replace('<br />', ' ').replace('<br/>', ' '),
        'event_label': event_label.replace('<br />', ' ').replace('<br/>', ' '),
        'vehicle_name': vehicle_name,
    })
    window.dataLayer.push({
        'event_category': undefined,
        'event_action': undefined,
        'event_label': undefined,
        'vehicle_name': undefined
    })
}

export const gtmModelPageInteractionWithCategory = (event_category, event_action, event_label) => {
    window.dataLayer.push({
        'event': 'model_page_interactions',
        'event_category': event_category.replace('<br />', ' ').replace('<br/>', ' '),
        'event_action': event_action.replace('<br />', ' ').replace('<br/>', ' '),
        'event_label': event_label.replace('<br />', ' ').replace('<br/>', ' '),
    })
    window.dataLayer.push({
        'event_category': undefined,
        'event_action': undefined,
        'event_label': undefined,
    })
}

export const gtmPageStart = () => {
    window.dataLayer.push({
        'event': 'configurator',
        'event_category': 'configuration',
        'event_action': 'configuration',
        'event_label': 'start'
    })
    window.dataLayer.push({
        'event_category': undefined,
        'event_action': undefined,
        'event_label': undefined
    })
}

export const gtmJourneyEvent = (event_action, event_label, vehicle_name, view_mode = null) => {
    window.dataLayer.push(view_mode === null ? {
        'event': 'configurator',
        'event_category': 'configuration',
        'event_action': event_action.replace('<br />', ' ').replace('<br/>', ' '),
        'event_label': event_label.replace('<br />', ' ').replace('<br/>', ' '),
        'vehicle_name': vehicle_name,
    } : {
        'event': 'configurator',
        'event_category': 'configuration',
        'event_action': event_action.replace('<br />', ' ').replace('<br/>', ' '),
        'event_label': event_label.replace('<br />', ' ').replace('<br/>', ' '),
        'vehicle_name': vehicle_name,
        'view_mode': view_mode,
    })
    window.dataLayer.push(view_mode === null ? {
        'event_category': undefined,
        'event_action': undefined,
        'event_label': undefined,
        'vehicle_name': undefined
    } : {
        'event_category': undefined,
        'event_action': undefined,
        'event_label': undefined,
        'vehicle_name': undefined,
        'view_mode': undefined
    })
}

export const gtmJourneyEventWithLightMode = (event_label, vehicle_name, lights_mode) => {
    window.dataLayer.push({
        'event': 'configurator',
        'event_category': 'configuration',
        'event_action': 'action spot',
        'event_label': event_label.replace('<br />', ' ').replace('<br/>', ' '),
        'vehicle_name': vehicle_name,
        'lights_mode': lights_mode
    })
    window.dataLayer.push({
        'event_category': undefined,
        'event_action': undefined,
        'event_label': undefined,
        'vehicle_name': undefined,
        'lights_mode': undefined
    })
}

export const gtmJourneyEventWithUspSpot = (feature, carBrand='', inOrEx='') => {
    window.dataLayer.push({
        'event': 'configurator',
        'event_category': 'configuration',
        'event_action': 'usp spot',
        'event_label': `select ${inOrEx} feature`,
        ...inOrEx === 'exterior' ? {'exterior_feature': feature.replace('<br />', ' ').replace('<br/>', ' ')} : {'interior_feature': feature.replace('<br />', ' ').replace('<br/>', ' ')},
        'vehicle_name': carBrand,
        'view_mode': inOrEx
    })
    window.dataLayer.push({
        'event_category': undefined,
        'event_action': undefined,
        'event_label': undefined,
        'exterior_feature': undefined,
        'interior_feature': undefined,
        'vehicle_name': undefined,
        'view_mode': undefined
    })
}

export const gtmJourneyEventWithCustomFields = (event_label, vehicle_name, view_mode, customFields = {}) => {
    let filteredFields = { ...customFields }
    Object.keys(customFields).map(key => filteredFields[key] = customFields[key].replace('<br />', ' ').replace('<br/>', ' '))
    window.dataLayer.push({
        'event': 'configurator',
        'event_category': 'configuration',
        'event_action': 'configuration options',
        'event_label': event_label.replace('<br />', ' ').replace('<br/>', ' '),
        'vehicle_name': vehicle_name,
        'view_mode': view_mode,
        ...filteredFields
    })
    let resetCustomFields = { ...customFields }
    Object.keys(resetCustomFields).map(key => resetCustomFields[key] = undefined)
    window.dataLayer.push({
        'event_category': undefined,
        'event_action': undefined,
        'event_label': undefined,
        'vehicle_name': undefined,
        'view_mode': undefined,
        ...resetCustomFields
    })
}

export const gtmGalleryInteraction = (event_label, vehicle_name) => {
    window.slideScroll = false
    window.dataLayer.push({
        'event': 'gallery page interactions',
        'event_category': 'gallery page interactions',
        'event_action': 'exterior',
        'event_label': event_label.replace('<br />', ' ').replace('<br/>', ' '),
        'vehicle_name': vehicle_name,
    })
    window.dataLayer.push({
        'event_category': undefined,
        'event_action': undefined,
        'event_label': undefined,
        'vehicle_name': undefined
    })
}

export const gtmShowroomGalleryInteraction = (event_label, vehicle_name) => {
    window.slideScroll = false
    window.dataLayer.push({
        'event': 'gallery page interactions',
        'event_category': 'gallery page interactions',
        'event_action': 'gallery',
        'event_label': event_label.replace('<br />', ' ').replace('<br/>', ' '),
        'vehicle_name': vehicle_name,
    })
    window.dataLayer.push({
        'event_category': undefined,
        'event_action': undefined,
        'event_label': undefined,
        'vehicle_name': undefined
    })
}